/**
 * Triggers a browser-native file download for the supplied binary blob.
 *
 * Implementation detail: a hidden anchor with `download={filename}` is
 * created, programmatically clicked, then immediately detached. The temporary
 * object URL is revoked asynchronously so Safari and Firefox have a tick to
 * begin the download before the URL becomes invalid.
 *
 * @param blob - The binary payload to deliver.
 * @param filename - The suggested filename (no path separators).
 */
export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.rel = 'noopener';
  anchor.style.display = 'none';

  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);

  setTimeout(() => URL.revokeObjectURL(url), 0);
}
